const API = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const SOCKET = process.env.REACT_APP_SOCKET_URL || 'http://localhost:4000';
export { API, SOCKET };